import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 10L7.67917 4.6357C7.76484 4.54872 7.88003 4.5 8 4.5C8.11997 4.5 8.23516 4.54872 8.32083 4.6357L13.5 10",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgChevronUp;
